import axios from 'axios';
import errorHandler from './errorHandler.js';

const handleError = errorHandler().handleError;

export default function (baseUrl) {
  const url = baseUrl || 'http://localhost:6542';

  const conf = token => {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  };

  function isLastPage(response) {
    if (
      response.data.page.totalPages === 0 ||
      response.data.page.number + 1 === response.data.page.totalPages
    ) {
      return true;
    }

    return false;
  }

  async function retrieveExternalSources(accessToken, customer, page = 0) {
    try {
      const path = `${url}/customers/${customer}/external-sources?page=${page}`;
      const response = await axios.get(path, conf(accessToken));
      if (isLastPage(response)) {
        return response.data.elements;
      }
      const nextPage = await retrieveExternalSources(
        accessToken,
        customer,
        page + 1
      );
      return [...response.data.elements, ...nextPage];
    } catch (error) {
      throw handleError(error);
    }
  }

  async function retrieveExternalSource(accessToken, customer, source) {
    try {
      const path = `${url}/customers/${customer}/external-sources/${source}`;
      const response = await axios.get(path, conf(accessToken));
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  }

  async function retrieveViews(accessToken, customer, source, page = 0) {
    try {
      const path = `${url}/customers/${customer}/external-sources/${source}/views?page=${page}`;
      const response = await axios.get(path, conf(accessToken));
      if (isLastPage(response)) {
        return response.data.elements;
      }
      const nextPage = await retrieveViews(
        accessToken,
        customer,
        source,
        page + 1
      );
      return [...response.data.elements, ...nextPage];
    } catch (error) {
      throw handleError(error);
    }
  }

  async function retrieveView(accessToken, customer, source, view) {
    try {
      const path = `${url}/customers/${customer}/external-sources/${source}/views/${view}`;
      const response = await axios.get(path, conf(accessToken));
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  }

  return {
    retrieveExternalSources,
    retrieveViews,
    retrieveExternalSource,
    retrieveView
  };
}
